const Builder = require('../BuilderBase');

module.exports = class ShortTextView extends Builder {
    constructor(title, properties) {
        super('dataView_ShortTextView', title, properties);
    }
};
